import "core-js/modules/es.object.assign.js";
var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
  }
  return t;
};
export function catLog(errObj, opts) {
  if (opts === void 0) {
    opts = {
      level: 'error',
      tags: {}
    };
  }
  if (window.Owl) {
    window.Owl.addError(errObj, opts);
  }
}
export var infoLog = function infoLog(errObj, opts) {
  catLog(errObj, __assign({}, opts, {
    level: 'info'
  }));
};
export var errorLog = function errorLog(errObj, opts) {
  catLog(errObj, __assign({}, opts, {
    level: 'error'
  }));
};
export var warnLog = function warnLog(errObj, opts) {
  catLog(errObj, __assign({}, opts, {
    level: 'warn'
  }));
};
export var knbLog = function knbLog(tags) {
  if (tags === void 0) {
    tags = {};
  }
  warnLog('KNB_Error', {
    tags: tags
  });
};